module.exports = __webpack_public_path__ + "media/chicken-road-lose.ad07b18c.mp3";